module.exports = __webpack_public_path__ + "media/images/Pin-outline-6628942f.svg";